import type {
  MapIcon,
  MapIconWithRaster,
} from 'features/mapping/mapping.types';
import { getWildfireMapRasterIcons } from './wildfireIcons.utils';
import { nonWildfireMapIcons } from './icons';

const mapIconsToRasters = (icons: MapIcon[]): MapIconWithRaster[] =>
  icons.map((icon) => {
    const img = new Image(icon.width, icon.height);
    img.src = icon.data;
    return { ...icon, img };
  });

let cachedNonWildfireMapIconsWithRasters: MapIconWithRaster[] | null = null;
let cachedWildfireMapIconsWithRasters: MapIconWithRaster[] | null = null;

const getNonWildfireMapIconsWithRasters = (): MapIconWithRaster[] => {
  if (!cachedNonWildfireMapIconsWithRasters) {
    cachedNonWildfireMapIconsWithRasters =
      mapIconsToRasters(nonWildfireMapIcons);
  }
  return cachedNonWildfireMapIconsWithRasters;
};

const getWildfireMapIconsWithRasters = (): MapIconWithRaster[] => {
  if (!cachedWildfireMapIconsWithRasters) {
    cachedWildfireMapIconsWithRasters = mapIconsToRasters(
      getWildfireMapRasterIcons(),
    );
  }
  return cachedWildfireMapIconsWithRasters;
};

export const getMapIconsWithRasters = (): MapIconWithRaster[] => [
  ...getWildfireMapIconsWithRasters(),
  ...getNonWildfireMapIconsWithRasters(),
];
